// How long a browser session may last, counted from the real sign-in time
// (the `auth_time` claim of the Firebase ID token, seconds since epoch).
//
// The API enforces the same limits with a 401. The web checks first so a user
// is signed out with a clear message instead of sitting on a page where every
// call fails.
//
// These two limits mirror api/app/services/session_service.py and must change
// with it.
export const WORKSPACE_SESSION_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
export const SYSTEM_ADMIN_SESSION_MAX_AGE_SECONDS = 24 * 60 * 60;

export const SIGNED_OUT_REASON_KEY = 'signedOutReason';
export const SIGNED_OUT_EXPIRED = 'expired';
export const SIGNED_OUT_REVOKED = 'revoked';

export const SIGNED_OUT_MESSAGES = {
  [SIGNED_OUT_EXPIRED]:
    'You were signed out because this session reached its time limit. Sign in again to continue.',
  [SIGNED_OUT_REVOKED]:
    'You were signed out because your access changed. Sign in again to continue.',
};

const isNumber = (value) => typeof value === 'number' && Number.isFinite(value);

export function sessionMaxAgeSeconds({ systemAdmin } = {}) {
  return systemAdmin
    ? SYSTEM_ADMIN_SESSION_MAX_AGE_SECONDS
    : WORKSPACE_SESSION_MAX_AGE_SECONDS;
}

// A token without a numeric auth_time is never judged here: the API decides.
export function isSessionExpired({ authTime, systemAdmin, nowMs = Date.now() } = {}) {
  if (!isNumber(authTime)) return false;
  return nowMs / 1000 - authTime > sessionMaxAgeSeconds({ systemAdmin });
}

// `sessionsRevokedAt` is epoch milliseconds, `authTime` is epoch seconds.
export function isSessionRevoked({ authTime, sessionsRevokedAt } = {}) {
  if (!isNumber(authTime) || !isNumber(sessionsRevokedAt)) return false;
  return sessionsRevokedAt > authTime * 1000;
}

export function signedOutMessage(reason) {
  return SIGNED_OUT_MESSAGES[reason] || null;
}
